(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!window.__mioraCopyInit) {
    window.__mioraCopyInit = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-copy-code]');
      if (!button) return;
      var code = button.getAttribute('data-copy-code');
      var label = button.querySelector('[data-copy-label]');
      if (label && !button.__orig) button.__orig = label.textContent;
      function done() {
        if (!label) return;
        label.textContent = button.getAttribute('data-copied-label') || button.__orig;
        clearTimeout(button.__timer);
        button.__timer = setTimeout(function () { label.textContent = button.__orig; }, 1800);
      }
      function fallback() {
        var area = document.createElement('textarea');
        area.value = code;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(area);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, fallback);
      } else {
        fallback();
      }
    });
  }
  if (!window.__mioraTimerInit) {
    window.__mioraTimerInit = true;
    var mioraTick = function () {
      var els = document.querySelectorAll('[data-mc-due]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var due = Date.parse(el.getAttribute('data-mc-due'));
        if (isNaN(due)) continue;
        var diff = Math.floor((due - Date.now()) / 1000);
        var wrap = el.closest('.mc__timer');
        if (diff < 0) {
          if (wrap) wrap.style.display = 'none';
          var bar = el.closest('.announcement-bar');
          if (bar) bar.style.display = 'none';
          continue;
        }
        var parts = {
          d: String(Math.floor(diff / 86400)),
          h: String(Math.floor((diff % 86400) / 3600)),
          m: String(Math.floor((diff % 3600) / 60)),
          s: String(diff % 60)
        };
        for (var key in parts) {
          var node = el.querySelector('[data-u="' + key + '"]');
          if (node) node.textContent = key === 'd' ? parts[key] : (parts[key].length < 2 ? '0' + parts[key] : parts[key]);
        }
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mioraTick);
    } else {
      mioraTick();
    }
    setInterval(mioraTick, 1000);
  }

  } catch(e) { console.error(e); }
})();
})();
